/* Midnight Snap — global theme JS
   Loaded site-wide. Handles sticky nav scroll state + mobile nav overlay.
*/
(function() {
  // Sticky nav scroll state
  var nav = document.getElementById('main-nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      nav.classList.toggle('is-scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  // Mobile nav overlay
  var hamburger = document.getElementById('hamburger');
  var overlay = document.getElementById('nav-overlay');
  var navClose = document.getElementById('nav-close');

  function openNav() {
    if (!overlay) return;
    overlay.classList.add('is-open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openNav);
  if (navClose) navClose.addEventListener('click', closeNav);
  if (overlay) {
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeNav();
    });
  }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeNav();
  });
})();
